import { render, staticRenderFns } from "./patternStrokeColorController.vue?vue&type=template&id=876719a8&"
import script from "./patternStrokeColorController.vue?vue&type=script&lang=ts&"
export * from "./patternStrokeColorController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports